var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoWhiteYunits = function SvgLogoWhiteYunits(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 774.202,
    height: 208.324,
    viewBox: "0 0 774.202 208.324",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00ffc2;\n      }\n\n      .cls-2 {\n        fill: #007bff;\n      }\n\n      .cls-3 {\n        fill: #0032a3;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9917",
    "data-name": "Group 9917",
    transform: "translate(-185.563 -428.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9853",
    "data-name": "Group 9853",
    transform: "translate(185.563 428.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    className: "cls-1",
    d: "M351.57,868.46l-17.577,61.862,27.4,85.7-51.7-.2-17.1,60.193,81.036.309L432.605,868.77Z",
    transform: "translate(-233.132 -868.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    className: "cls-2",
    d: "M351.952,868.6l-81.036-.309L318.143,1016l29.339.111,24.295-85.507Z",
    transform: "translate(-270.916 -868.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    className: "cls-3",
    d: "M323.126,891.014l-24.295,85.508,51.7.2",
    transform: "translate(-222.265 -828.699)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(746.774 10.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    className: "cls-4",
    d: "M585.214,880a13.714,13.714,0,1,0,13.714,13.714A13.712,13.712,0,0,0,585.214,880Zm7.345,21.059a10.381,10.381,0,1,1,3.045-7.344A10.335,10.335,0,0,1,592.559,901.059Z",
    transform: "translate(-571.5 -880)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    className: "cls-4",
    d: "M583.931,890.109a3.986,3.986,0,0,0,.694-.921,4.594,4.594,0,0,0,.437-1.091,4.759,4.759,0,0,0,.154-1.207,4.338,4.338,0,0,0-.332-1.654,4.892,4.892,0,0,0-.921-1.462,4.7,4.7,0,0,0-1.4-1.048,3.918,3.918,0,0,0-1.758-.4h-6.08V895.82h3.116v-4.35h2.033l2.583,4.35h3.517L583.01,890.8A4.042,4.042,0,0,0,583.931,890.109Zm-2.29-1.881a1.165,1.165,0,0,1-.949.523h-2.85v-3.685H580.6a1.326,1.326,0,0,1,.987.494,1.876,1.876,0,0,1,.455,1.33A2.144,2.144,0,0,1,581.641,888.228Z",
    transform: "translate(-565.876 -875.943)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    className: "cls-4",
    d: "M60.6,76.054v35.027H37.715V75.771L-.56,12.215H23.733L50.144,56.14,76.555,12.215H99.012Zm79.234,36.722q-21.186,0-32.979-11.723T95.057,67.58V12.215h22.88V66.732q0,26.553,22.033,26.553,10.734,0,16.383-6.426T162,66.732V12.215h22.6V67.58q0,21.751-11.793,33.473T139.83,112.776ZM286.575,12.215v98.866H267.79L218.5,51.055v60.026H195.9V12.215h18.926l49.15,60.026V12.215Zm12.146,0H321.6v98.866h-22.88Zm55.506,18.643H322.59V12.215h86.155V30.858H377.108v80.223h-22.88Zm87.284,81.917a80.891,80.891,0,0,1-22.669-3.178q-10.946-3.178-17.584-8.262L409.027,84.1A52.713,52.713,0,0,0,424.14,91.59a56.764,56.764,0,0,0,17.513,2.825q9.745,0,14.406-2.9t4.661-7.7a7.358,7.358,0,0,0-2.754-5.861,20.879,20.879,0,0,0-7.062-3.743q-4.308-1.412-11.652-3.107a161.067,161.067,0,0,1-18.5-5.367,30.06,30.06,0,0,1-12.358-8.615q-5.155-5.932-5.155-15.819A27.517,27.517,0,0,1,407.9,25.7q4.661-6.991,14.053-11.087t22.951-4.1a76,76,0,0,1,18.5,2.26,54.659,54.659,0,0,1,15.819,6.5L472.16,36.649q-13.7-7.768-27.4-7.768-9.6,0-14.194,3.107a9.485,9.485,0,0,0-4.59,8.192q0,5.085,5.3,7.556t16.172,4.873a161.069,161.069,0,0,1,18.5,5.367A30.638,30.638,0,0,1,478.3,66.45q5.155,5.791,5.155,15.677a27,27,0,0,1-4.731,15.465Q474,104.584,464.533,108.68T441.512,112.776Z",
    transform: "translate(259.87 37.218)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoWhiteYunits, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_white_yunits.61357e7f.svg";
export { ForwardRef as ReactComponent };